import React from 'react';

interface EmployeeInformationProps {
  employee: {
    employeeId?: string;
    employeeName?: string;
    name_of_employee?: string;
    designation?: string;
    department?: string;
    email?: string;
    managerName?: string;
    reporting_manager?: string;
    managerEmail?: string;
    nominationAs?: string;
    peer?: string;
    // For API reviewee object
    emp_id?: string;
    name?: string;
    manager?: {
      manager_id?: number;
      manager_name?: string;
      manager_email?: string;
    };
  };
  showNominationInfo?: boolean;
  title?: string;
}

const EmployeeInformation: React.FC<EmployeeInformationProps> = ({ 
  employee, 
  showNominationInfo = false, 
  title = "Employee Information" 
}) => {
  // Prefer API reviewee fields if present
  const employeeId = employee?.employeeId || employee?.emp_id;
  const employeeName = employee?.employeeName || employee?.name_of_employee || employee?.name;
  const designation = employee?.designation;
  const managerName = employee?.managerName || employee?.reporting_manager || employee?.manager?.manager_name;
  const managerEmail = employee?.manager?.manager_email;

  return (
    <div className="">
      <div className="border rounded text-primary-800 text-base font-regular font-verdana mb-4 bg-custom-light-purple p-1 pl-2">
        {title}
      </div>
      <div className="grid grid-cols-1 gap-1 px-2 sm:px-3 lg:grid-cols-2 lg:gap-8">
        <div className="space-y-3">
          <div className="flex flex-col gap-1 py-2 sm:flex-row sm:py-3">
            <span className="text-gray-500 text-sm sm:w-40 sm:shrink-0">Employee ID</span>
            <span className="break-words text-gray-900 text-sm">{employeeId || '-'}</span>
          </div>
          <div className="flex flex-col gap-1 py-2 sm:flex-row sm:py-3">
            <span className="text-gray-500 text-sm sm:w-40 sm:shrink-0">Designation</span>
            <span className="break-words text-gray-900 text-sm">{designation || '-'}</span>
          </div>
          {/* <div className="flex py-3">
            <span className="text-gray-500 text-sm w-40">Department</span>
            <span className="text-gray-900 text-sm">{department}</span>
          </div>
          {email && (
            <div className="flex py-3">
              <span className="text-gray-500 text-sm w-40">Email</span>
              <span className="text-gray-900 text-sm">{email}</span>
            </div>
          )} */}
        </div>
        <div className="space-y-3">
          {showNominationInfo && employee?.nominationAs && (
            <div className="flex flex-col gap-1 py-2 sm:flex-row sm:py-3">
              <span className="text-gray-500 text-sm sm:w-40 sm:shrink-0">Nomination as</span>
              <span className="break-words text-gray-900 text-sm">{employee.nominationAs || '-'}</span>
            </div>
          )}
          <div className="flex flex-col gap-1 py-2 sm:flex-row sm:py-3">
            <span className="text-gray-500 text-sm sm:w-40 sm:shrink-0">Name of Employee</span>
            <span className="break-words text-gray-900 text-sm">{employeeName || '-'}</span>
          </div>
          <div className="flex flex-col gap-1 py-2 sm:flex-row sm:py-3">
            <span className="text-gray-500 text-sm sm:w-40 sm:shrink-0">Reporting Manager</span>
            <span className="break-words text-gray-900 text-sm">{managerName || '-'}</span>
          </div>
          {managerEmail && (
            <div className="flex flex-col gap-1 py-2 sm:flex-row sm:py-3">
              <span className="text-gray-500 text-sm sm:w-40 sm:shrink-0">Manager Email</span>
              <span className="break-all text-gray-900 text-sm">{managerEmail || '-'}</span>
            </div>
          )}
          {showNominationInfo && employee?.peer && (
            <div className="flex flex-col gap-1 py-2 sm:flex-row sm:py-3">
              <span className="text-gray-500 text-sm sm:w-40 sm:shrink-0">Peer</span>
              <span className="break-words text-gray-900 text-sm">{employee.peer || '-'}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmployeeInformation;
